<div class="container">
  @if (state() === 'loading') {
    <div class="card is-processing">
      <div class="status-chip processing">
        <i class="pi pi-spin pi-cog"></i>
      </div>
      <h2>{{ 'processingLoad.loadingTitle' | translate }}</h2>
      <p class="subtitle">
        {{ 'processingLoad.loadingDescription' | translate }}
      </p>
      <div class="progress-track" aria-hidden="true">
        <div class="progress"></div>
      </div>
      <div class="helper-notice">
        <i class="pi pi-lock"></i>
        <span>{{ 'processingLoad.loadingNotice' | translate }}</span>
      </div>
    </div>
  }
  @if (state() === 'success') {
    <div class="card is-success">
      <div class="status-chip success">
        <i class="pi pi-check"></i>
      </div>
      <h2>{{ 'processingLoad.successTitle' | translate }}</h2>
      <p class="subtitle">
        {{ 'processingLoad.successDescription' | translate }}
      </p>
      @if (loadId()) {
        <div class="load-id-section">
          <div class="load-id-header">
            <i class="pi pi-hashtag"></i>
            <span>{{ 'processingLoad.loadIdLabel' | translate }}</span>
          </div>
          <div class="load-id-row">
            <code class="load-id-code">{{ loadId() }}</code>
            <button
              type="button"
              class="copy-button"
              (click)="copyLoadId()"
              [attr.aria-label]="
                copied()
                  ? ('table.copy.idCopied' | translate)
                  : ('table.copy.copyId' | translate)
              "
            >
              <i class="pi" [class]="copied() ? 'pi-check' : 'pi-copy'"></i>
            </button>
          </div>
          @if (copied()) {
            <span class="copy-feedback">
              <i class="pi pi-check"></i>
              {{ 'processingLoad.copiedToClipboard' | translate }}
            </span>
          }
        </div>
      }
      <div class="success-actions">
        <a class="view-loads-link" routerLink="/reporte">
          {{ 'processingLoad.viewUploadedLoads' | translate }}
          <i class="pi pi-arrow-right"></i>
        </a>
        <div class="btn-wrapper">
          <app-button
            [data]="{
              id: 'new-upload',
              label: 'processingLoad.newUpload' | translate,
              icon: 'pi-cloud-upload'
            }"
            [severity]="'primary'"
            (click)="newLoad.emit()"
          >
          </app-button>
        </div>
      </div>
    </div>
  }
  @if (state() === 'error') {
    <div class="card is-error">
      <div class="status-chip error">
        <i class="pi pi-times"></i>
      </div>
      <h2>{{ 'processingLoad.errorTitle' | translate }}</h2>
      <p class="subtitle">
        {{ 'processingLoad.errorDescription' | translate }}
      </p>
      <div class="error-detail">
        <div class="error-detail-header">
          <i class="pi pi-exclamation-circle"></i>
          <span>{{ 'processingLoad.errorDetailTitle' | translate }}</span>
        </div>
        @for (code of errorUploadFile()?.codes ?? []; track code.key) {
          <p class="error-message" [innerHTML]="code.message"></p>
        }
      </div>
      <div class="error-actions">
        @if (errorUploadFile()?.fileBase64) {
          <div class="download-btn-wrapper">
            <app-button
              [data]="{
                id: 'download-template',
                icon: 'pi pi-cloud-download',
                label: 'processingLoad.downloadTemplateWithErrors' | translate
              }"
              severity="primary"
              (click)="downloadTemplateWithErrors.emit()"
            />
          </div>
        }
        <div class="section-wrapper">
          @if (!hasRateLimitExceededError()) {
            <div class="retry-btn-wrapper">
              <app-button
                [data]="{
                  id: 'retry',
                  icon: 'pi pi-refresh',
                  label: 'processingLoad.retry' | translate
                }"
                severity="primary"
                (click)="retryLoad.emit()"
              />
            </div>
          }
          <div class="btn-wrapper">
            <app-button
              [data]="{
                id: 'retry',
                icon: 'pi pi-cloud-upload',
                label: 'processingLoad.newUpload' | translate
              }"
              severity="primary"
              (click)="newLoad.emit()"
            />
          </div>
        </div>
      </div>
    </div>
  }
</div>
